import * as React from 'react'

import { Icon } from '~ui/components/icons/Icon'
import { IconInfo } from '~ui/components/icons/specific/IconInfo'
import { Flex, GridRow } from '~ui/components/layout/Box'
import { H3 } from '~ui/components/typography/Heading/Heading'
import { Text } from '~ui/components/typography/Text/Text'

type TCartItemSpecial = {
  /**
   * name of the ware item
   */
  nameLabel: string
  /**
   * item price with the currency abbreviation
   */
  price: string
  /**
   * action to be executed when the item is clicked
   */
  onClick?: () => void
}

type TProps = NoChildren & {
  /**
   * special item (such as covers) data to be rendered
   */
  wareItem: TCartItemSpecial
}

export const CartItemSpecial: React.FC<TProps> = ({ wareItem }) => {
  const isClickable = Boolean(wareItem.onClick)

  return (
    <Flex justifyContent={`space-between`}>
      <GridRow
        alignItems={`center`}
        columnGap={`small`}
        onClick={wareItem.onClick}
        cursor={isClickable ? `pointer` : undefined}
      >
        <H3 fontSize={`m16`}>{wareItem.nameLabel}</H3>
        {isClickable && <Icon icon={IconInfo} iconSize={`1rem`} contrast={`low`} />}
      </GridRow>

      <Text fontStyle={`bold`} fontSize={`m16`}>
        {wareItem.price}
      </Text>
    </Flex>
  )
}
